import { render, staticRenderFns } from "./target_job.vue?vue&type=template&id=c1968dca&scoped=true"
import script from "./target_job.vue?vue&type=script&lang=js"
export * from "./target_job.vue?vue&type=script&lang=js"
import style0 from "./target_job.vue?vue&type=style&index=0&id=c1968dca&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1968dca",
  null
  
)

export default component.exports